<template>
  <v-card outlined rounded class="payment-methods-empty px-4 py-4 text-center" data-test="payment-methods-empty">
    <div class="text-subtitle-1 font-weight-semi-bold lapis--text text--lighten-2">
      {{ $t('fields.account.billing.payment.payment_methods_empty_title') }}
    </div>

    <div class="text-body-2 neutral--text text--darken-1 mt-1">
      {{ $t('fields.account.billing.payment.payment_methods_empty_description') }}
    </div>

    <v-btn
      v-if="isTeamLead"
      text
      :ripple="false"
      color="primary"
      class="mt-2"
      :disabled="disabled"
      data-test="payment-methods-empty-add"
      @click="onAdd"
    >
      <span class="navy--text"> {{ $t('fields.account.billing.payment.payment_methods_add') }} + </span>
    </v-btn>
  </v-card>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PaymentMethodListEmpty extends Vue {
  @Prop({ default: false })
  isTeamLead!: boolean;

  @Prop({ default: false })
  disabled!: boolean;

  @Emit('add')
  onAdd(): void {
    // Opens the add-payment-method dialog in the parent list.
  }
}
</script>
